<div id="error-500" fxLayout="column" fxLayoutAlign="center center">

    <div class="content" fxLayout="column" fxLayoutAlign="center center">

        <div class="logo">
            <mat-icon class="mat-accent s-96">email</mat-icon>
        </div>

        <div class="message">¡Lo siento, usuario deshabilitado!</div>

        <div class="sub-message">
            Debes verficar tu cuenta de correo o contactar al administrador.
        </div>

        <a class="report-link" [routerLink]="'/pages/auth/login'">ir al inicio</a>

    </div>

</div>
